/**
 * DevExtreme (esm/renovation/ui/scroll_view/common/consts.js)
 * Version: 24.1.8
 * Build date: Mon Dec 16 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
export const SCROLL_LINE_HEIGHT = 40;
export const DIRECTION_VERTICAL = "vertical";
export const DIRECTION_HORIZONTAL = "horizontal";
export const DIRECTION_BOTH = "both";
export const SCROLLABLE_SIMULATED_CLASS = "dx-scrollable-simulated";
export const SCROLLABLE_CONTENT_CLASS = "dx-scrollable-content";
export const SCROLLABLE_WRAPPER_CLASS = "dx-scrollable-wrapper";
export const SCROLLABLE_CONTAINER_CLASS = "dx-scrollable-container";
export const SCROLLABLE_DISABLED_CLASS = "dx-scrollable-disabled";
export const SCROLLABLE_SCROLLBAR_SIMULATED = "dx-scrollable-scrollbar-simulated";
export const SCROLLABLE_SCROLLBARS_HIDDEN = "dx-scrollable-scrollbars-hidden";
export const SCROLLABLE_SCROLLBARS_ALWAYSVISIBLE = "dx-scrollable-scrollbars-alwaysvisible";
export const SCROLLABLE_SCROLLBAR_CLASS = "dx-scrollable-scrollbar";
export const SCROLLABLE_SCROLLBAR_ACTIVE_CLASS = "dx-scrollable-scrollbar-active";
export const SCROLLABLE_SCROLL_CLASS = "dx-scrollable-scroll";
export const SCROLLABLE_SCROLL_CONTENT_CLASS = "dx-scrollable-scroll-content";
export const HOVER_ENABLED_STATE = "dx-scrollbar-hoverable";
export const SCROLLVIEW_CONTENT_CLASS = "dx-scrollview-content";
export const SCROLLVIEW_TOP_POCKET_CLASS = "dx-scrollview-top-pocket";
export const SCROLLVIEW_PULLDOWN = "dx-scrollview-pull-down";
export const SCROLLVIEW_PULLDOWN_LOADING_CLASS = "dx-scrollview-pull-down-loading";
export const SCROLLVIEW_PULLDOWN_READY_CLASS = "dx-scrollview-pull-down-ready";
export const SCROLLVIEW_PULLDOWN_IMAGE_CLASS = "dx-scrollview-pull-down-image";
export const SCROLLVIEW_PULLDOWN_INDICATOR_CLASS = "dx-scrollview-pull-down-indicator";
export const SCROLLVIEW_PULLDOWN_TEXT_CLASS = "dx-scrollview-pull-down-text";
export const SCROLLVIEW_PULLDOWN_VISIBLE_TEXT_CLASS = "dx-scrollview-pull-down-text-visible";
export const PULLDOWN_ICON_CLASS = "dx-icon-pulldown";
export const SCROLLVIEW_BOTTOM_POCKET_CLASS = "dx-scrollview-bottom-pocket";
export const SCROLLVIEW_REACHBOTTOM_CLASS = "dx-scrollview-scrollbottom";
export const SCROLLVIEW_REACHBOTTOM_INDICATOR_CLASS = "dx-scrollview-scrollbottom-indicator";
export const SCROLLVIEW_REACHBOTTOM_TEXT_CLASS = "dx-scrollview-scrollbottom-text";
export const TopPocketState = {
    STATE_RELEASED: 0,
    STATE_READY: 1,
    STATE_REFRESHING: 2,
    STATE_LOADING: 3,
    STATE_TOUCHED: 4,
    STATE_PULLED: 5
};
export const ShowScrollbarMode = {
    HOVER: "onHover",
    ALWAYS: "always",
    NEVER: "never",
    SCROLL: "onScroll"
};
export const KEY_CODES = {
    PAGE_UP: "pageUp",
    PAGE_DOWN: "pageDown",
    END: "end",
    HOME: "home",
    LEFT: "leftArrow",
    UP: "upArrow",
    RIGHT: "rightArrow",
    DOWN: "downArrow"
};
export const VALIDATE_WHEEL_TIMEOUT = 500;
export const HIDE_SCROLLBAR_TIMEOUT = 500;
